import { render } from "./Vouchers.vue?vue&type=template&id=b0b16d56&scoped=true"
import script from "./Vouchers.vue?vue&type=script&lang=js"
export * from "./Vouchers.vue?vue&type=script&lang=js"

import "./Vouchers.vue?vue&type=style&index=0&id=b0b16d56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b16d56"]])

export default __exports__